// ---------------------------------------------------------------------------
// Contrat d'événements analytics.
//
// RÈGLE DE RÉSILIENCE : les métriques de l'admin (visiteurs, taux CTA,
// complétion onboarding, churn, LTV) sont calculées UNIQUEMENT à partir des
// noms d'événements ci-dessous — jamais à partir d'URLs, de composants ou de
// structure de pages. Vous pouvez refondre la landing, l'onboarding ou le
// funnel librement : tant que le nouveau code émet les mêmes noms, tous les
// tableaux de bord continuent de fonctionner sans modification.
//
// Pour ajouter une étape : ajoutez un nom ici, émettez-le, puis ajoutez-le au
// funnel dans lib/admin-metrics.ts. Ne renommez jamais un événement existant
// (créez-en un nouveau et dépréciez l'ancien si besoin).
// ---------------------------------------------------------------------------

export const EVENTS = {
  /** Vue de la landing page (1 événement par page vue). */
  LANDING_VIEWED: "landing_viewed",
  /** Clic sur un call-to-action de la landing (propriété `cta` = emplacement). */
  CTA_CLICKED: "cta_clicked",
  /** Lecture de la vidéo de présentation de la landing (1 par chargement de page). */
  LANDING_VIDEO_PLAYED: "landing_video_played",
  /** Arrivée sur le formulaire d'inscription. */
  SIGNUP_VIEWED: "signup_viewed",
  /** Compte créé avec succès. */
  SIGNUP_COMPLETED: "signup_completed",
  /** Arrivée sur l'onboarding. */
  ONBOARDING_STARTED: "onboarding_started",
  /** Onboarding terminé (profil enregistré). */
  ONBOARDING_COMPLETED: "onboarding_completed",
  /** Analyse lancée depuis l'app. */
  ANALYSIS_STARTED: "analysis_started",
  /** Analyse terminée avec succès. */
  ANALYSIS_COMPLETED: "analysis_completed",
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];

export const EVENT_NAME_PATTERN = /^[a-z][a-z0-9_.]{1,63}$/;

export interface TrackPayload {
  name: string;
  anonymousId?: string;
  sessionId?: string;
  path?: string;
  referrer?: string;
  properties?: Record<string, string | number | boolean | null>;
}
